import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { RouteId } from "../enums/env/routes-id-enum";
import { RouteEnv } from "../interfaces/env/RouteEnv";
import { MainRoute } from "../models/MainRoute";
import { RightService } from "./right.service";

@Injectable({
  providedIn: 'root',
})
export class RoutingService {

  constructor(private rightService: RightService) {
  }

  public static getRoute(routeId: RouteId): MainRoute {
    return new MainRoute(RoutingService.searchRoute(routeId), routeId);
  }

  public getRoutesLeftMenu(): MainRoute[] {
    const listRoute = [];
    environment.core.routes.forEach(r => {
      switch(r.id) {
        case RouteId.DASHBOARD:
          const canAccessDashboard: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessDashboard) {
            listRoute.push(r);
          }
          break;
        case RouteId.DASHBOARD_GNL:
          const canAccessDashboardGNL: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessDashboardGNL) {
            listRoute.push(r);
          }
          break;
        case RouteId.MAP:
          const canAccessMap: boolean = this.rightService.canAccessAdministration();
          if(r.enabled) {
            listRoute.push(r);
          }
          break;
        case RouteId.EMS:
          if(r.enabled) {
            listRoute.push(r);
          }
          break;
        case RouteId.REGIONS:
          const canAccessRegions: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessRegions) {
            listRoute.push(r);
          }
          break;
        case RouteId.ALARMS:
          const canAccessAlarms: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessAlarms) {
            listRoute.push(r);
          }
          break;
        case RouteId.TICKETS:
          const canAccessTickets: boolean = this.rightService.canAccessTickets();
          if(r.enabled && canAccessTickets) {
            listRoute.push(r);
          }
          break;
        case RouteId.STATIONS:
          const canAccessStations: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessStations) {
            listRoute.push(r);
          }
          break;
        case RouteId.GRAPHS:
          const canAccessGraph: boolean = this.rightService.canAccessSiteOperationManagement();
          if(r.enabled && canAccessGraph) {
            listRoute.push(r);
          }
          break;
        case RouteId.SUBSCRIPTIONS:
          const canAccessSubscriptions: boolean = this.rightService.canAccessSubscriptions();
          if(r.enabled && canAccessSubscriptions) {
            listRoute.push(r);
          }
          break;
        case RouteId.BADGES:
          const canAccessBadges: boolean = this.rightService.canAccessBadges();
          if(r.enabled && canAccessBadges) {
            listRoute.push(r);
          }
          break;
        case RouteId.USERS:
          const canAccessUsers: boolean = this.rightService.canAccessUsers();
          if(r.enabled && canAccessUsers) {
            listRoute.push(r);
          }
          break;
        case RouteId.VEHICLES:
          const canAccessVehicle: boolean = this.rightService.canAccessVehicle();
          if(r.enabled && canAccessVehicle) {
            listRoute.push(r);
          }
          break;
        case RouteId.EXPORT:
          if(r.enabled) {
            listRoute.push(r);
          }
          break;
        case RouteId.ADMINISTRATION:
          const canAccessAdministration: boolean = this.rightService.canAccessAdministration();
          if(r.enabled && canAccessAdministration) {
            listRoute.push(r);
          }
          break;
        case RouteId.ADMINISTRATION_DETAILS:
          if(r.enabled) {
            listRoute.push(r);
          }
          break;
      }
    });

    return listRoute;
  }

  public static getPathRoute(routeId: RouteId): string {
    return RoutingService.getRoute(routeId).path;
  }

  private static searchRoute(routeId: RouteId): RouteEnv {
    let found: RouteEnv = null;
    environment.core.routes.forEach(r => {
      if (r.id === routeId) {
        found = r;
      } else if (r.tabs) {
        const sub = r.tabs.find(sub => sub.id === routeId);
        if (sub) {
          found = sub;
        }
      }
    });

    return found;
  }

  public static getStationRoute(): MainRoute {
    return RoutingService.getRoute(RouteId.STATIONS);
  }
}
